export const isObject = (item: any) => {
  return item && typeof item === "object" && !Array.isArray(item);
};

export const deepMerge = (target: any, ...sources: [any, ...any[]]): any => {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        deepMerge(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return deepMerge(target, ...sources);
};

export const isEmpty = (target: any) => Object.keys(target).length === 0;
